module.exports = "/_next/static/images/IWD2023-fb89e502aab052b0fbe1f96f7a626045.jpg";